import { ClerkTokenInjector } from './ClerkTokenInjector';

export const Interceptor = {
  ClerkTokenInjector,
};
